import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  //成绩
  function result() {
    let i = 1;
    i++;
    if (i % 3 == 1) {
      Bus.$emit("result", { sort: desc });
    } else if (i % 3 == 2) {
      Bus.$emit("result", { sort: asc });
    } else {
      Bus.$emit("result", { sort: "" });
    }
  }
  // 学员作业
  function handleDownloadFile(enroll) {
    if (enroll.attachment) {
      Bus.$emit("downloadEnrollAuditFile", enroll);
    }
  }
  const Deal = ({ props: { vo } }) => {
    const data = vo.row;
    if (vo.row.attachment) {
      return (
        <div class="deal-group">
          <el-tooltip
            content="学员作业"
            placement="top"
            style="margin-right:20px"
          >
            <i class="el-tooltip icon-down"
              onClick={() => handleDownloadFile(vo.row)}
            ></i>
          </el-tooltip>
        </div>
      );
    } else {
      return (
        <div class="deal-group">
          <el-tooltip
            content="学员作业"
            placement="top"
            style="margin-right:20px"
          >
            <i class="el-tooltip icon-down-disable"
            ></i>
          </el-tooltip>
        </div>
      );
    }

  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "学员姓名",
      prop: "userName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "完成情况",
      prop: "finishStatusName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "作业附件",
      prop: "attachmentName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "成绩",
      prop: "workResult",
      minWidth: "150",
      sortable: true,
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => result()}
        >
          {vo.row.workResult}
        </el-button>
      )
    },
    {
      label: "批阅人",
      prop: "reviewer",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
